import React from "react";
import ArrowUp from "./img/arrowUp.svg";
import ArrowDown from "./img/arrowDown.svg";

export default function TableHeader({
  sortConfig,
  handleSort,
  headers = [],
  showEmptyHeader = false,
  draggable,
  module,
}) {
  const renderSortIcon = (key) => {
    if (sortConfig?.key === key) {
      return (
        <img
          src={sortConfig.direction === "asc" ? ArrowUp : ArrowDown}
          alt=""
          className="sort-icon"
          aria-hidden="true"
        />
      );
    }
    return null;
  };

  const getAriaSort = (header) => {
    if (!header.sortable) return undefined;
    if (sortConfig?.key !== header.key) return "none";
    return sortConfig.direction === "asc" ? "ascending" : "descending";
  };

  return (
    <thead>
      <tr>
        {draggable && <th scope="col" />}
        {headers.map((header) => (
          <th
            key={header.key}
            scope="col"
            className={module ? `table-col table-col--${header.key}` : undefined}
            aria-sort={getAriaSort(header)}
          >
            {header.sortable ? (
              <button
                type="button"
                className="table-header-sort-button"
                onClick={() => handleSort(header.key)}
              >
                <span>{header.name}</span>
                {renderSortIcon(header.key)}
              </button>
            ) : (
              header.name
            )}
          </th>
        ))}
        {showEmptyHeader && <th scope="col" />}
      </tr>
    </thead>
  );
}
